// @ts-check

import { fetchData } from '../utils/http-utils';

/**
 * @returns {Promise<{
 *    userRoles: string [],
 *    principalId: string,
 *    featureFlags?: object
 * }>}
 */
async function getUserContext() {
  try {
    /** @type {AxiosResponse<RoleResponse>} */
    const { data } = await fetchData(`/me`);

    return {
      userRoles: data.roles,
      principalId: data.principal_id,
      featureFlags: data.feature_flags,
    };
  } catch (err) {
    return {
      userRoles: [],
      principalId: '',
    };
  }
}

function getSSOName() {
  try {
    let cookies = decodeURIComponent(document.cookie).split('; ');
    const ssoNameCookie = cookies.find((c) => c.includes('SSONAME'));
    const ssoNameCookieValue = ssoNameCookie.split('=')?.[1];
    return ssoNameCookieValue;
  } catch (error) {
    return '';
  }
}

export { getUserContext, getSSOName };
